// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"319":"081875d2","8285":"7c33bc35"}[chunkId] + ".chunk.css";
};